import React, { Fragment } from 'react'
import { Transition } from '@headlessui/react'
import PropTypes from 'prop-types'
import { Dialog } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import clsx from 'clsx'

const TimeLineModal = ({ isOpen, setIsOpen, steps }) => {
    const closeModal = () => {
        setIsOpen && setIsOpen(false)
    }

    const renderSteps = () => {
        return (
            <div className="flex flex-col items-start justify-start w-full max-w-full gap-y-4">
                {steps?.map(step => {
                    return (
                        <div
                            className="w-full h-12 flex flex-row items-start justify-start gap-x-4"
                            key={step?.name}
                        >
                            <div className="w-0.5 h-full bg-grayLines">
                                <div
                                    className={clsx(
                                        'w-0.5 h-full',
                                        step?.finish === true &&
                                            'h-full bg-yellow',
                                        step?.active === true &&
                                            'h-1/2 bg-yellow',
                                    )}
                                ></div>
                            </div>
                            <div className="w-full h-auto flex flex-col items-start justify-start gap-y-0">
                                <p className="text-base text-textDarkerGray font-medium">
                                    {step?.name}
                                </p>
                                {step?.description && (
                                    <p className="text-textDarkGray font-medium text-sm">
                                        {step?.description}
                                    </p>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <>
            <Transition appear show={isOpen}>
                <Dialog
                    as="div"
                    className="relative z-200"
                    onClose={() => closeModal()}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-modalBackground" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center text-center md:px-0 px-4">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-3xl bg-white md:p-12 p-6 text-center transition-all relative flex flex-col items-center justify-start gap-y-6">
                                    <XIcon
                                        className="w-4 h-4 stroke-current stroke-2 absolute text-textDarkerGray top-6 right-6 cursor-pointer"
                                        onClick={closeModal}
                                    />
                                    <Dialog.Title
                                        as="h1"
                                        className="text-lg text-black90 font-semibold"
                                    >
                                        Status History
                                    </Dialog.Title>
                                    {renderSteps()}
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

TimeLineModal.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    steps: PropTypes.array,
}

export default TimeLineModal
